<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.9288 4.47997C14.7911 4.47997 13.8311 3.55553 13.8311 2.41775C13.8311 1.27997 14.7911 0.35553 15.9288 0.35553C17.0666 0.35553 17.9911 1.27997 17.9911 2.41775C17.9911 3.55553 17.0666 4.47997 15.9288 4.47997Z"
      fill="white"
    />
    <path
      d="M18.5955 11.3067V8.00001C18.5955 6.50668 17.3866 5.29779 15.9288 5.29779C14.4355 5.29779 13.2266 6.50668 13.2266 8.00001V11.3067H18.5955Z"
      fill="white"
    />
    <path
      d="M17.671 12.9422H14.1866L12.4443 15.9644L14.1866 18.9511H17.671L19.4132 15.9644L17.671 12.9422Z"
      fill="#00A8E8"
    />
    <path
      d="M15.9289 31.5733C14.7911 31.5733 13.8667 30.6489 13.8667 29.5111C13.8667 28.3378 14.7911 27.4133 15.9289 27.4133C17.0667 27.4133 18.0267 28.3378 18.0267 29.5111C18.0267 30.6489 17.0667 31.5733 15.9289 31.5733Z"
      fill="white"
    />
    <path
      d="M13.2622 20.6222V23.9289C13.2622 25.3867 14.4711 26.5956 15.9289 26.5956C17.4222 26.5956 18.6311 25.3867 18.5955 23.9289V20.5867L13.2622 20.6222Z"
      fill="white"
    />
    <path
      d="M4.19552 11.2711C3.05775 11.2711 2.1333 10.3466 2.1333 9.17331C2.1333 8.03553 3.05775 7.11108 4.19552 7.11108C5.3333 7.11108 6.2933 8.03553 6.2933 9.17331C6.2933 10.3466 5.3333 11.2711 4.19552 11.2711Z"
      fill="white"
    />
    <path
      d="M13.2266 11.3067L10.3822 9.67112C9.10217 8.92445 7.43106 9.35112 6.71995 10.6311C5.97328 11.9111 6.39995 13.5467 7.67995 14.2933L10.5599 15.9645L13.2266 11.3067Z"
      fill="white"
    />
    <path
      d="M27.6623 24.7822C26.5245 24.7822 25.6001 23.8577 25.6001 22.72C25.6001 21.5822 26.5245 20.6222 27.6623 20.6222C28.8001 20.6222 29.7245 21.5822 29.7245 22.72C29.7245 23.8577 28.8001 24.7822 27.6623 24.7822Z"
      fill="white"
    />
    <path
      d="M18.6311 20.6222L21.4755 22.2577C22.7555 23.0044 24.4267 22.5422 25.1378 21.2622C25.8844 19.9822 25.4578 18.3466 24.1778 17.6L21.2978 15.9644L18.6311 20.6222Z"
      fill="white"
    />
    <path
      d="M4.19552 24.8178C3.05775 24.8178 2.1333 23.8578 2.1333 22.72C2.1333 21.5822 3.05775 20.6578 4.19552 20.6578C5.36886 20.6578 6.2933 21.5822 6.2933 22.72C6.2933 23.8578 5.36886 24.8178 4.19552 24.8178Z"
      fill="white"
    />
    <path
      d="M10.5599 15.9644L7.67995 17.6C6.39995 18.3466 5.97328 19.9822 6.71995 21.2622C7.46661 22.5777 9.10217 23.0044 10.3822 22.2577L13.2622 20.6222L10.5599 15.9644Z"
      fill="white"
    />
    <path
      d="M27.6622 11.2355C26.4889 11.2355 25.5645 10.3111 25.5645 9.17331C25.5645 8.03553 26.4889 7.11108 27.6622 7.11108C28.8 7.11108 29.7245 8.03553 29.7245 9.17331C29.7245 10.3111 28.8 11.2355 27.6622 11.2355Z"
      fill="#00A8E8"
    />
    <path
      d="M21.2978 15.9644L24.1778 14.2933C25.4578 13.5466 25.8844 11.9111 25.1378 10.6311C24.3911 9.35109 22.7555 8.92442 21.4755 9.63554L18.6311 11.3066L21.2978 15.9644Z"
      fill="#00A8E8"
    />
  </svg>
</template>
<script setup lang="ts"></script>
